import { render, staticRenderFns } from "./AliPay.vue?vue&type=template&id=aa99b240&"
import script from "./AliPay.vue?vue&type=script&lang=js&"
export * from "./AliPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports